import { render } from "./FilterDistributorByArea.vue?vue&type=template&id=c7997c52"
import script from "./FilterDistributorByArea.vue?vue&type=script&lang=js"
export * from "./FilterDistributorByArea.vue?vue&type=script&lang=js"
script.render = render

export default script